export default __webpack_public_path__ + "static/media/function-2.66fb8ea7.png";